<div class="d-flex align-items-center justify-content-center min-vh-100">
  <app-empty-state icon="bi-shield-lock" title="No access configured" [message]="message">
    <button type="button" class="btn btn-outline-primary" (click)="signOut()">Sign out</button>
  </app-empty-state>
</div>
